"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantCreationViewModel = exports.TenantAdminCreationViewModel = exports.TenantDetailsCreationViewModel = void 0;
require("reflect-metadata");
var class_transformer_1 = require("class-transformer");
var index_1 = require("../../index");
var TenantDetailsCreationViewModel = /** @class */ (function () {
    function TenantDetailsCreationViewModel() {
        this.address1 = '';
        this.address2 = null;
        this.advancedAssetSharingAccess = false;
        this.aliasCarrierIdAccess = false;
        this.autoAccept = false;
        this.automaticInvitationResendsDefault = false;
        this.carrierNetworkRoles = [];
        this.city = '';
        this.country = '';
        this.dotNumber = null;
        this.mcNumber = null;
        this.name = '';
        this.notificationType = index_1.TenantEnums.NotificationTypeEnum.NONE;
        this.provider = false;
        this.purpose = index_1.TenantEnums.PurposeEnum.PRODUCTION;
        this.salesforceAccountId = null;
        this.scac = null;
        this.stateProvinceRegion = '';
        this.showToPublic = false;
        this.subscriber = false;
        this.tenantId = null;
        this.tenantUuid = null;
        this.vatNo = null;
        this.zip = '';
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "address1", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "address2", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "advancedAssetSharingAccess", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "aliasCarrierIdAccess", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "autoAccept", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "automaticInvitationResendsDefault", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Array)
    ], TenantDetailsCreationViewModel.prototype, "carrierNetworkRoles", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "city", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "country", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "dotNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "mcNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "notificationType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "provider", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "purpose", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "salesforceAccountId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "scac", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "stateProvinceRegion", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "showToPublic", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Boolean)
    ], TenantDetailsCreationViewModel.prototype, "subscriber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "tenantId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "tenantUuid", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantDetailsCreationViewModel.prototype, "vatNo", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantDetailsCreationViewModel.prototype, "zip", void 0);
    return TenantDetailsCreationViewModel;
}());
exports.TenantDetailsCreationViewModel = TenantDetailsCreationViewModel;
var TenantAdminCreationViewModel = /** @class */ (function () {
    function TenantAdminCreationViewModel() {
        this.familyName = '';
        this.givenName = '';
        this.locale = '';
        this.password = null;
        this.username = '';
        this.phoneNumber = '';
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantAdminCreationViewModel.prototype, "familyName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantAdminCreationViewModel.prototype, "givenName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantAdminCreationViewModel.prototype, "locale", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], TenantAdminCreationViewModel.prototype, "password", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantAdminCreationViewModel.prototype, "username", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantAdminCreationViewModel.prototype, "phoneNumber", void 0);
    return TenantAdminCreationViewModel;
}());
exports.TenantAdminCreationViewModel = TenantAdminCreationViewModel;
var TenantCreationViewModel = /** @class */ (function () {
    function TenantCreationViewModel() {
        this.tenant = new TenantDetailsCreationViewModel();
        this.user = new TenantAdminCreationViewModel();
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return TenantDetailsCreationViewModel; }),
        __metadata("design:type", TenantDetailsCreationViewModel)
    ], TenantCreationViewModel.prototype, "tenant", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return TenantAdminCreationViewModel; }),
        __metadata("design:type", TenantAdminCreationViewModel)
    ], TenantCreationViewModel.prototype, "user", void 0);
    return TenantCreationViewModel;
}());
exports.TenantCreationViewModel = TenantCreationViewModel;
